// src/helpers/rutaCarteras.js
import axios from "axios";

// DANLU - React CRA
const RAW_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://backdanlu.eu-4.evennode.com";

const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
});

const p = (s) => String(s || "").replace(/^\/+/, "");

// token header: el back usa "token"
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || "";
  if (token) config.headers.token = token;
  return config;
});

const parseErr = (e) =>
  e?.response?.data?.msg ??
  e?.response?.data?.err ??
  e?.response?.data?.error ??
  e?.response?.data?.message ??
  e?.message ??
  "Error desconocido";

/**
 * GET /cartera
 */
export const getCartera = async ({
  tipo,
  estado,
  empresa,
  clienteId,
  terceroId,
  proveedorId,
  desde,
  hasta,
  texto,
} = {}) => {
  try {
    const { data } = await API.get(p("cartera"), {
      params: {
        ...(tipo ? { tipo } : {}),
        ...(estado ? { estado } : {}),
        ...(empresa ? { empresa } : {}),
        ...(clienteId ? { clienteId } : {}),
        ...(terceroId ? { terceroId } : {}),
        ...(proveedorId ? { proveedorId } : {}),
        ...(desde ? { desde } : {}),
        ...(hasta ? { hasta } : {}),
        ...(texto ? { texto } : {}),
      },
    });

    return data;
  } catch (e) {
    return { ok: false, msg: parseErr(e), items: [] };
  }
};

/**
 * GET /cartera/disponibles
 */
export const getCarteraDisponibles = async ({
  estados,
  tipo,
  cobradoA,
  pagadoA,
  empresa,
  clienteId,
  terceroId,
  proveedorId,
} = {}) => {
  try {
    const { data } = await API.get(p("cartera/disponibles"), {
      params: {
        ...(estados
          ? { estados: Array.isArray(estados) ? estados.join(",") : estados }
          : {}),
        ...(tipo ? { tipo } : {}),
        ...(cobradoA ? { cobradoA } : {}),
        ...(pagadoA ? { pagadoA } : {}),
        ...(empresa ? { empresa } : {}),
        ...(clienteId ? { clienteId } : {}),
        ...(terceroId ? { terceroId } : {}),
        ...(proveedorId ? { proveedorId } : {}),
      },
    });

    return data;
  } catch (e) {
    return { ok: false, msg: parseErr(e), items: [] };
  }
};

/**
 * GET /cartera/resumen
 */
export const getCarteraResumen = async ({ tipo, desde, hasta } = {}) => {
  try {
    const { data } = await API.get(p("cartera/resumen"), {
      params: {
        ...(tipo ? { tipo } : {}),
        ...(desde ? { desde } : {}),
        ...(hasta ? { hasta } : {}),
      },
    });

    return data;
  } catch (e) {
    return { ok: false, msg: parseErr(e), resumen: [], total: 0 };
  }
};

/**
 * POST /cartera/inicial
 */
export const postCarteraInicial = async (payload) => {
  try {
    const { data } = await API.post(p("cartera/inicial"), payload);
    return data;
  } catch (e) {
    return Promise.reject(new Error(parseErr(e)));
  }
};

/**
 * PUT /cartera/:id
 */
export const putCartera = async (id, payload) => {
  try {
    const url = p(`cartera/${encodeURIComponent(String(id))}`);
    const { data } = await API.put(url, payload);
    return data;
  } catch (e) {
    return Promise.reject(new Error(parseErr(e)));
  }
};

/**
 * PUT /cartera/:id/estado
 */
export const putCarteraEstado = async (id, payload) => {
  try {
    const url = p(`cartera/${encodeURIComponent(String(id))}/estado`);
    const { data } = await API.put(url, payload);
    return data;
  } catch (e) {
    return Promise.reject(new Error(parseErr(e)));
  }
};

/**
 * DELETE /cartera/:id
 */
export const deleteCartera = async (id, payload = {}) => {
  try {
    const url = p(`cartera/${encodeURIComponent(String(id))}`);
    const { data } = await API.delete(url, { data: payload });
    return data;
  } catch (e) {
    return Promise.reject(new Error(parseErr(e)));
  }
};